import { combineReducers } from 'redux'
import oAuthReducer from './oauth'

export default combineReducers({
  oAuth: oAuthReducer
})
